var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg43(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.082 6.95312L1.32812 0L21.1914 50L48.8672 16.2695L39.082 6.95312ZM38.4766 10.0195L44.2578 15.5078L28.457 18.3594L38.4766 10.0195ZM25.0195 17.793L8.35938 3.98438L35.5859 8.98438L25.0195 17.793ZM23.8281 20.2344L21.1133 42.6758L6.46484 5.83984L23.8281 20.2344ZM26.3477 21.4258L43.8477 18.2617L23.7695 42.6953L26.3477 21.4258Z",
    fill: "#EB0029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg43);
export default __webpack_public_path__ + "static/media/43.544b4dbf3f2fe3255d8d5bd457ae0db4.svg";
export { ForwardRef as ReactComponent };